module.exports = __webpack_public_path__ + "static/media/w_w_hb_45.abb2d26d.png";